import React from "react";
import { useAppContext } from "../context/AppContext";

// Reusable PineTree
const PineTree = ({ x, y, scale = 1, color1 = "#4a5c3a", color2 = "#5d7049" }) => (
  <g transform={`translate(${x},${y}) scale(${scale})`}>
    <polygon points="0,-40 15,0 -15,0" fill={color1} />
    <polygon points="0,-30 12,0 -12,0" fill={color2} />
    <rect x="-2" y="0" width="4" height="12" fill="#6b5644" />
  </g>
);

const WPAVendorBanner = () => {
  // Static random stars for dark mode, same as WPANationalParksBanner
  const { darkMode } = useAppContext();
  // Responsive logo and text size based on window width
  const [windowWidth, setWindowWidth] = React.useState(typeof window !== 'undefined' ? window.innerWidth : 1200);
  React.useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Calculate scale factors for logo and text
  let logoW = 150, logoH = 115, logoX = 525, logoY = 20, fontSize = 34, textY = 200;
  if (windowWidth < 640) { // mobile
    logoW = 90; logoH = 69; logoX = 555; logoY = 10; fontSize = 20; textY = 170;
  } else if (windowWidth < 1024) { // tablet
    logoW = 120; logoH = 92; logoX = 540; logoY = 15; fontSize = 26; textY = 185;
  }
  return (
    <div className="rounded-xl overflow-hidden w-full">
      <svg
        viewBox="0 0 1200 220"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="w-full h-32 sm:h-48 md:h-56 lg:h-64"
        role="img"
        aria-labelledby="title"
        preserveAspectRatio="xMidYMid slice"
        style={{ display: "block" }}
      >
        <title id="title">WPA-style Vendor Banner with River</title>
        <defs>
          {/* Sky gradients */}
          <linearGradient id="skyGradVendor" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor={darkMode ? "#1a2236" : "#dce4ea"} />
          <stop offset="100%" stopColor={darkMode ? "#2a314a" : "#a9b9c7"} />
        </linearGradient>
        {/* Sun/Moon gradients */}
        <linearGradient id="sunGradVendor" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor={darkMode ? "#e6e7ef" : "#fce38a"} />
          <stop offset="100%" stopColor={darkMode ? "#bfc3d9" : "#f7d488"} />
        </linearGradient>
        <radialGradient id="sunRaysVendor" cx="50%" cy="50%" r="50%">
          <stop
            offset="60%"
            stopColor={darkMode ? "#e6e7ef" : "#fce38a"}
            stopOpacity={darkMode ? "0.12" : "0.3"}
          />
          <stop offset="100%" stopColor={darkMode ? "#e6e7ef" : "#fce38a"} stopOpacity="0" />
        </radialGradient>
      </defs>

      {/* Sky background */}
      <rect width="1200" height="220" fill="url(#skyGradVendor)" />

      {/* Stars in dark mode, same as GearPage banner */}
      {darkMode ? (
        <g>
          {[...Array(40)].map((_, i) => (
            <circle
              key={i}
              cx={Math.random() * 1200}
              cy={Math.random() * 120}
              r={Math.random() * 1.5 + 0.5}
              fill="#fff"
              opacity={Math.random() * 0.5 + 0.5}
            />
          ))}
        </g>
      ) : null}

      {/* Smoky Mountains style layers (shifted toward #638171) */}
      <path
        d="M0 170 Q200 110 400 170 T800 170 T1200 170 V220 H0Z"
        fill={darkMode ? "#4e5f5a" : "#5a746b"}  // deeper teal-gray
        opacity="0.7"
      />
      <path
        d="M0 190 Q300 130 600 190 T1200 190 V220 H0Z"
        fill={darkMode ? "#5c6f68" : "#6b857a"}  // mid-tone around #638171
        opacity="0.8"
      />
      <path
        d="M0 210 Q400 160 800 210 T1200 210 V220 H0Z"
        fill={darkMode ? "#70857c" : "#7e988e"}  // lighter variation
        opacity="0.9"
      />

      {/* Sun / Moon */}
      <circle cx="180" cy="60" r="32" fill="url(#sunGradVendor)" />
      <circle cx="180" cy="60" r="70" fill="url(#sunRaysVendor)">
        <animate attributeName="r" values="60;80;60" dur="6s" repeatCount="indefinite" />
      </circle>

      {/* Winding river in foreground */}
      <path
        d="M300 220 Q500 180 650 200 Q800 210 1000 180 Q1200 160 1200 220 Z"
        fill={darkMode ? "#4a6075" : "#6fb3d2"}
        opacity="0.9"
      />
      <path
        d="M320 220 Q520 185 670 205 Q820 215 1020 185 Q1200 170 1200 220 Z"
        fill={darkMode ? "#5c7690" : "#8cc6e0"}
        opacity="0.7"
      />


      {/* Centered image and text at the top of the banner */}
      <image
        href="https://www.outdoorec.com/wp-content/uploads/2020/06/services.icon_.explore.800x615.png"
        x={logoX}
        y={logoY}
        width={logoW}
        height={logoH}
        style={{ transform: 'translateX(0)' }}
      />
      <text
        x="600"
        y={textY}
        textAnchor="middle"
        fontFamily="'Times New Roman', Times, serif"
        fontWeight="normal"
        fontSize={18}
        fill={darkMode ? "#bdbdbd" : "#4b5563"}
        letterSpacing="0.02em"
        style={{
          textTransform: 'none',
          filter: 'none',
        }}
      >
        Discover trails, plan adventures, and check local weather and park conditions—all in one place.
      </text>
      </svg>
    </div>
  );
};

export default WPAVendorBanner;
